import { NgModule } from '@angular/core';
import { PageComponent } from '@cargeny/pages/page.component';
import { PageRoutingModule } from '@cargeny/pages/page-routing.module';
import { NavComponent } from '@cargeny/shared/components/nav/nav.component';
import { FooterComponent } from '@cargeny/shared/components/footer/footer.component';
import { ModalSearchComponent } from '@shared/components/modal/modal-search/modal-search.component';

@NgModule({
  declarations: [PageComponent],
  imports: [PageRoutingModule, NavComponent, FooterComponent, ModalSearchComponent],
})
export class PageModule {}
